<template>
  <div class="modal-form">
    <h3 class="card-title">Cargar diagnóstico</h3>
    <form @submit.prevent="save">
      <pd-input
        v-model="nombre"
        id="nombre"
        label="Nombre"
        placeholder="Ingrese el nombre del diagnóstico"
        class="my-1"
        :required="enviado && !$v.nombre.required"
      ></pd-input>
      <button class="btn btn-right btn-primary">Guardar</button>
    </form>
  </div>
</template>
<script>
import { DiagnosticosServices } from "../services/DiagnosticosServices";
import Swal from "sweetalert2";
export default {
  name: "NuevoDiagnostico",
  data() {
    return {
      nombre: "",
      enviado: false,
    };
  },
  validations: {
    ...DiagnosticosServices.validations,
  },
  methods: {
    save() {
      this.enviado = true;
      if (!this.nombre) {
        return false;
      }
      DiagnosticosServices.api
        .create(this.nombre)
        .then((r) => {
          if (r.success) {
            Swal.fire("Éxito", `<p><b>${r.diagnostico.nombre}</b> se ha guardado con éxito</p>`, "success");
            this.$emit("saved");
          } else {
            Swal.fire("Error", `<p>${r.message}</p>`, "error");
          }
        })
        .catch((e) => {
          Swal.fire("Error", `<p>${e}</p>`, "error");
        });
    },
  },
};
</script>
